import { IPatient, IDocument, IMinimalPatient } from '@/interfaces';
import { IPatientComment } from '@/features/patients/patient-comments/types';
import { PatientState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
  clearPatients(state: PatientState) {
    state.patients = []
  },
  setPatients(state: PatientState, payload: IPatient[]) {
    console.log('Received #', payload.length, 'patients')
    const payload_ids = payload.map((a) => a.id);
    state.patients = state.patients.filter((a) => !payload_ids.includes(a.id));
    state.patients.push(...payload);
    console.log('Total length now #', state.patients.length, 'patients')
  },
  setPatient(state: PatientState, payload: IPatient) {
    const patients = state.patients.filter((patient: IPatient) => patient.id !== payload.id);
    patients.push(payload);
    state.patients = patients;
  },
  setComments(state: PatientState, payload: IPatientComment[]) {
    state.patient_comments = payload;
  },
  setComment(state: PatientState, payload: IPatientComment) {
    const comments = state.patient_comments.filter((comment: IPatientComment) => comment.id !== payload.id);
    comments.push(payload);
    state.patient_comments = comments;
  },
  setDocumentsForPatient(state: PatientState, payload: { patientId: number, docs: IDocument[] }) {

    const patients = state.patients.filter((p: IPatient) => p.id !== payload.patientId);
    const patient = state.patients.filter((p: IPatient) => p.id == payload.patientId)[0];
    patient.documents = payload.docs
    patients.push(patient);
    state.patients = patients;
  },
  setMinimalPatient(state: PatientState, payload: IMinimalPatient) {
    state.minimalPatients = { ...state.minimalPatients, [payload.id]: payload };
  },
};

const { commit } = getStoreAccessors<PatientState, State>('');

export const commitSetPatient = commit(mutations.setPatient);
export const commitClearPatients = commit(mutations.clearPatients)
export const commitSetPatients = commit(mutations.setPatients);
export const commitSetComment = commit(mutations.setComment);
export const commitSetComments = commit(mutations.setComments);
export const commitSetDocumentsForPatient = commit(mutations.setDocumentsForPatient);
export const commitSetMinimalPatient = commit(mutations.setMinimalPatient);